import { Box, Typography } from "@mui/material";
import LoadingIcon from "../../components/LoadingIcon";

/**
 * Demo component for LoadingIcon
 * Shows different variations and sizes of the LoadingIcon component
 */
const LoadingIconDemo = () => (
  <Box display="flex" alignItems="center" gap={3}>
    <Box display="flex" alignItems="center" gap={1}>
      <LoadingIcon />
      <Typography variant="body2">Default</Typography>
    </Box>
    <Box display="flex" alignItems="center" gap={1}>
      <LoadingIcon type="dots" />
      <Typography variant="body2">Dots</Typography>
    </Box>
    <Box display="flex" alignItems="center" gap={1}>
      <LoadingIcon size={30} />
      <Typography variant="body2">Custom Size</Typography>
    </Box>
  </Box>
);

export default LoadingIconDemo;
